
// URL → State reading (called on page load and popstate)
export const readUrlState = (): Partial<Record<string, string>> => {
  const params = new URLSearchParams(window.location.search)
  const result: Record<string, string> = {}
  for (const [key, value] of params.entries()) {
    result[key] = value
  }
  return result
}

// Specific route state readers
export const readGraphUrlState = () => {
  const params = new URLSearchParams(window.location.search)
  return {
    focusId: params.get('focus_id') || undefined,
    pinned: params.get('pinned')?.split(',').filter(Boolean) || [],
    editPerms: params.get('edit_perms') === 'true',
  }
}

export const readSignupUrlState = () => {
  const params = new URLSearchParams(window.location.search)
  return { inviteToken: params.get('invite_token') || undefined }
}

export const readResetPasswordUrlState = () => {
  const params = new URLSearchParams(window.location.search)
  return { resetToken: params.get('reset_token') || undefined }
}

// Keep currentUrl for backward compat (used by middleware/api/axios.ts)
export const currentUrl = () => {
  return `${window.location.pathname}${window.location.search}`
}

// URL → State on popstate (browser back/forward)
export const setupPopstateListener = (dispatch: (action: { type: string; payload?: { id: string } }) => void) => {
  window.addEventListener('popstate', () => {
    if (window.location.pathname !== '/graph') return
    const { focusId } = readGraphUrlState()
    dispatch({
      type: 'FOCUS_GRAPH_ENTITY',
      payload: { id: focusId || '' },
    })
  })
}

// State → URL writing middleware
export const urlSyncMiddleware = (store: any) => {
  let lastFocusId: string | undefined
  let lastPinned: string | undefined
  let lastEditPerms: boolean | undefined

  return (next: any) => (action: any) => {
    const result = next(action)
    const state = store.getState()

    if (window.location.pathname !== '/graph') return result

    const focusId = state.graph?.focus?.id
    const pinnedNodes = state.graph?.pinned?.nodes
    const editPerms = (state.permissions as { newContent?: { expanded?: boolean } } | undefined)?.newContent?.expanded

    const pinnedStr = pinnedNodes ? Object.keys(pinnedNodes).join(',') : ''

    if (focusId === lastFocusId && pinnedStr === lastPinned && editPerms === lastEditPerms) {
      return result
    }

    lastFocusId = focusId
    lastPinned = pinnedStr
    lastEditPerms = editPerms

    const params: string[] = []
    if (focusId) params.push(`focus_id=${encodeURIComponent(focusId)}`)
    if (pinnedStr) params.push(`pinned=${pinnedStr}`)  // commas are URL-safe, don't encode
    if (editPerms) params.push('edit_perms=true')

    const search = params.length ? `?${params.join('&')}` : ''
    const newUrl = `${window.location.pathname}${search}`
    if (newUrl !== `${window.location.pathname}${window.location.search}`) {
      window.history.pushState(null, '', newUrl)
    }

    return result
  }
}
